module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAPCAYAAAAVk7TYAAAAAXNSR0IArs4c6QAAAMNJREFUOE+t1LENwjAUhOH/FgExAGsgajagR6JnCipqpqCmYQGmoAQpDdVDhgSCcOLn4HSWYn8+yz4BmJmAqaRzGJf8zGwMXCXdVEM7YAksJB1KYWY2AY7ABZiFRCHZFlgD91JgCxoBJ2D+xEqDUUiq3lgpsAsK639h/4J9UBQbCqagTiwX9EC9mBf0QkksBeZALqwLzIXcWAQMBbABPg9WqlLN83P1+ya0mqb57dUMDigrWaRpsqBBWH2kK2DvTdRs9AHSNpclsfdyyQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiala.png
// module id = X0mH
// module chunks = 1